// extracted by mini-css-extract-plugin
export default {"root":"app_root__nRJ89","content":"app_content__kzxes"};